import { Check, HelpCircle, X } from 'lucide-react';

export type DialogVariant = 'success' | 'error' | 'warning';

export const VARIANT_CONFIG = {
	success: {
		icon: Check,
		colorClass: 'bg-green-500',
		defaultConfirmText: 'Tutup'
	},
	error: {
		icon: X,
		colorClass: 'bg-red-500',
		defaultConfirmText: 'Coba Lagi'
	},
	warning: {
		icon: HelpCircle,
		colorClass: 'bg-yellow-400',
		defaultConfirmText: 'Ya, Lanjutkan'
	}
};
